import axios from 'axios';
import { environment } from '../environment/environment';
import { User } from '../types/UserTypes';

export interface Auth0LoginPayload {
  token: string;
}

class UserAuthApiService {
  private readonly baseUrl = environment.baseUrl;

  async login({ token }: { token: string }): Promise<User> {
    const response = await axios.post(
      `${this.baseUrl}/auth/auth0/login/`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  }

  async logout(): Promise<void> {
    await axios.get(`${this.baseUrl}/auth/logout/`);
  }

  async getCurrentUser(): Promise<User> {
    const response = await axios.get(`${this.baseUrl}/auth/user/`);
    return response.data;
  }

  async getCsrfToken(): Promise<string | null> {
    const response = await axios.get(`${this.baseUrl}/auth/csrf/`, {
      withCredentials: true,
    });
    return response.headers['x-csrftoken'] || null;
  }
}

export const userAuthApiService = new UserAuthApiService();